import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processModifiedCustomizedData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks?: Remark[],
): BinderSectionData => {
  const processedModifiedCustomizedData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const hasModifiedCustomized =
        vehicle?.is_modified_customized !== undefined
          ? vehicle.is_modified_customized
          : false;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        remarks: remarks?.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        hasModifiedCustomized,
        isValid: !hasModifiedCustomized,
      };
    }),
  };

  // Overall modified/customized validation
  const isModifiedCustomizedValid =
    processedModifiedCustomizedData.vehicles.every(
      (vehicle) => vehicle.isValid,
    );
  const modifiedCustomizedMessage = !isModifiedCustomizedValid
    ? 'One or more vehicles have been modified or customized'
    : null;

  return {
    title: 'Modified or customized',
    description:
      'Have any vehicles on the application been modified or customized?',
    isValid: isModifiedCustomizedValid,
    message: modifiedCustomizedMessage,
    data: processedModifiedCustomizedData,
  };
};
